import { cloneElement, FC, isValidElement, ReactElement, useCallback, useRef } from 'react';
import { useAnalytics } from '@cld/analytics';
import { NavigationSkeleton } from '@cld/navigation-menu';
import { SideMenu, SideMenuProps } from '../../components/SideMenu';
import { ApplicationsDropdownInlineTrigger } from '../DefaultApplicationsDropdown/ApplicationsDropdownInlineTrigger/ApplicationsDropdownInlineTrigger';
import { useUserData } from '../../context';
import { StyledHeaderSkeleton } from './DefaultSideMenu.styles';

export const DefaultSideMenu: FC<SideMenuProps> = ({ children, header, footer }) => {
  const analytics = useAnalytics('side menu');
  const sideMenuRef = useRef<HTMLElement>(null);
  const { userData } = useUserData();

  const dropdownRelativeContainer = () => sideMenuRef.current!;
  const footerComponent = isValidElement(footer) && cloneElement(footer as ReactElement, { getTooltipContainer: dropdownRelativeContainer });

  const toggleCallback = useCallback(
    (isOpen: boolean) => {
      analytics(`${isOpen ? 'expand' : 'collapse'} side menu`, `${isOpen ? 'show' : 'hide'}`);
    },
    [analytics]
  );

  const onFloatChange = useCallback(
    (isOpen: boolean) => {
      analytics(`${isOpen ? 'expand' : 'collapse'} floating side menu`, `${isOpen ? 'show' : 'hide'}`);
    },
    [analytics]
  );

  return userData ? (
    <SideMenu
      ref={sideMenuRef}
      header={header === undefined ? <ApplicationsDropdownInlineTrigger getTooltipContainer={dropdownRelativeContainer} /> : header}
      footer={footerComponent}
      toggleCallback={toggleCallback}
      onFloatChange={onFloatChange}
      children={children}
    />
  ) : (
    <SideMenu header={<StyledHeaderSkeleton isLoading />} ref={sideMenuRef}>
      <NavigationSkeleton />
    </SideMenu>
  );
};
